import React, { CSSProperties, useState } from "react";
import { CheckedInAction } from "src/components/CheckedIn/CheckedInSiteStyles";
import { CheckedInIcon } from "src/components/CheckedIn/CheckedInIcon";
import { CompanyQuote } from "./quotesApi";
import { ArticleAction, QuoteArtwork, QuotePanel } from "./QuotesViewerStyles";

interface QuoteCardProps {
    quote: CompanyQuote;
    full: boolean;
    onOpen: () => void;
    onArticle: () => void;
    onClose: () => void;
}

export function QuoteCard({ quote, full, onOpen, onArticle, onClose }: QuoteCardProps): React.ReactElement {
    const [imageFailed, setImageFailed] = useState<boolean>(false);
    const [articleImageFailed, setArticleImageFailed] = useState<boolean>(false);
    const image: string | undefined = quote.imageUrl || quote.thumbnailUrl;
    const customization = quote.customization;
    const alignment: string = customization?.verticalAlign || "center";
    const style: CSSProperties = {
        color: customization?.textColor || (image && !imageFailed ? "#fff" : "#000"),
        fontFamily: customization?.textFont || "Archivo, sans-serif",
        fontSize: `${customization?.fontSize || 28}px`,
        textAlign: (customization?.textAlign || "center") as CSSProperties["textAlign"],
        justifyContent: alignment === "top" ? "flex-start" : alignment === "bottom" ? "flex-end" : "center"
    };
    const label: string = quote.quoteText || "Quote image";
    return <QuotePanel $full={full} aria-label={label}>
        <QuoteArtwork $interactive={!full} role={full ? undefined : "button"} tabIndex={full ? undefined : 0}
            aria-label={full ? undefined : `Open ${label}`} onClick={full ? undefined : onOpen}
            onKeyDown={event => {
                if (!full && (event.key === "Enter" || event.key === " ")) {
                    event.preventDefault();
                    onOpen();
                }
            }}>
            {image && !imageFailed && <img src={image} alt={quote.quoteText ? "" : "Quote artwork"}
                loading={full ? "eager" : "lazy"} onError={() => setImageFailed(true)} />}
            {(quote.quoteText || quote.author) && <blockquote style={style}>{quote.quoteText}
                {quote.author && <cite>{quote.author}</cite>}</blockquote>}
            {(!image || imageFailed) && !quote.quoteText && <blockquote style={style}>Quote image unavailable.</blockquote>}
        </QuoteArtwork>
        {full && <CheckedInAction type="button" $round onClick={onClose} aria-label="Close quote">
            <CheckedInIcon name="close" /></CheckedInAction>}
        {quote.article && !quote.article.deleted_at && <ArticleAction>
            <CheckedInAction type="button" onClick={onArticle}>
                {quote.article.imageUrl && !articleImageFailed && <img src={quote.article.imageUrl} alt=""
                    onError={() => setArticleImageFailed(true)} />}
                <span><strong>Read the Article</strong><span>{quote.article.title}</span></span>
                <CheckedInIcon name="forward" />
            </CheckedInAction>
        </ArticleAction>}
    </QuotePanel>;
}
